export default {
    ws: 'ws://39.97.240.15:8888',
    setWs: function (newWs) {
        this.ws = newWs
    }
}



// WEBPACK FOOTER //
// ./src/utis/toTop.js